/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type createGroupV2MutationVariables = {|
  selectedTenant: string,
  name: string,
  userId?: ?string,
|};
export type createGroupV2MutationResponse = {|
  +addUserGroupV2: ?{|
    +name: string,
    +uuid: string,
  |}
|};
export type createGroupV2Mutation = {|
  variables: createGroupV2MutationVariables,
  response: createGroupV2MutationResponse,
|};
*/


/*
mutation createGroupV2Mutation(
  $selectedTenant: String!
  $name: String!
  $userId: String
) {
  addUserGroupV2(tenantUuid: $selectedTenant, name: $name, userId: $userId) {
    name
    uuid
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedTenant"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "tenantUuid",
        "variableName": "selectedTenant"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "GroupV2",
    "kind": "LinkedField",
    "name": "addUserGroupV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createGroupV2Mutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "createGroupV2Mutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "aac742ab6080d8adccdba7aec215d801",
    "id": null,
    "metadata": {},
    "name": "createGroupV2Mutation",
    "operationKind": "mutation",
    "text": "mutation createGroupV2Mutation(\n  $selectedTenant: String!\n  $name: String!\n  $userId: String\n) {\n  addUserGroupV2(tenantUuid: $selectedTenant, name: $name, userId: $userId) {\n    name\n    uuid\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '665cad45253d04e8370b3ced933de9c4';

module.exports = node;
